export default __webpack_public_path__ + "static/media/spaceman6.19fd5ed8.png";